import User from "./User";
import Editor from "./Editor";
import Library from "./Library";
import ManageAccount from "./ManageAccount";
import Scheduler from "./Scheduler";
import Analyser from "./Analyser";
import Projects from "./Projects";

// All the routes
export const routes = [
  { path: "/home", component: User },
  {
    path: "/timeline",
    component: User,
  },
  {
    path: "/moodboards",
    component: User,
  },
  {
    path: "/surveys",
    component: User,
  },
  {
    path: "/analyser",
    component: Analyser,
  },
  {
    path: ["/scheduler/:itemId", "/scheduler"],
    component: Scheduler,
  },
  {
    path: "/editor",
    component: Editor,
  },
  {
    path: ["/library/:type", "/library"],
    component: Library,
  },
  {
    path: "/settings",
    component: ManageAccount,
  },
  {
    path: "/projects",
    component: Projects,
  },
  {
    path: "/projectSettings",
    component: ManageAccount,
  },
];

export const getUserPaths = routes
  .filter((route) => route.component === User)
  .flatMap((route) => route.path);
